<div class="timeline-holder left">
    <div class="content">
      <h2>April-2020</h2>
      <p>First production ready Boldungu  release called ankunda is made available to very close friends and family. Boldungu is met with excitement</p>
    </div>
  </div>
